<template>
  <FocusTrap>
    <div class="card">
      <div class="card-header header-elements-inline">
        <legend class="font-weight-semibold text-uppercase font-size-sm">
          <i class="icon-file-text2"></i>
          Enter Buyer information
        </legend>
        <div class="header-elements">
          <div class="list-icons">
            <a class="list-icons-item" data-action="reload"></a>
            <a class="list-icons-item" data-action="remove" @click="closeWindow"></a>
          </div>
        </div>
      </div>
      <!-- Tab Navigation -->
      <div class="card-body p-0">
        <ul class="nav nav-tabs nav-tabs-highlight">
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: activeTab === 'billingaddress' }"
              href="#"
              @click.prevent="activeTab = 'billingaddress'"
            >
              Billing Address
            </a>
          </li>
          <!-- Added Shipping Address Tab -->
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: activeTab === 'shippingaddress' }"
              href="#"
              @click.prevent="activeTab = 'shippingaddress'"
            >
              Shipping Address
            </a>
          </li>
        </ul>
        <!-- Tab Content -->
        <div class="tab-content p-3">
          <!-- Billing Address Tab -->
          <div
            class="tab-pane fade"
            :class="{ 'show active': activeTab === 'billingaddress' }"
          >
            <div class="form-group row">
              <label class="col-md-2 col-form-label">Name:</label>
              <div class="col-md-10">
                <input
                  ref="txtname"
                  type="text"
                  id="txtname"
                  class="form-control"
                  placeholder="Buyer Name"
                  maxlength="100"
                  v-if="buyer"
                  v-model="buyer.name"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-2 col-form-label">Add 1:</label>
              <div class="col-md-10">
                <textarea
                  rows="1"
                  class="form-control"
                  placeholder="Enter address here"
                  v-if="buyer"
                  v-model="buyer.add1"
                ></textarea>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-2 col-form-label">Add 2:</label>
              <div class="col-md-10">
                <textarea
                  rows="1"
                  class="form-control"
                  placeholder="Enter address here"
                  v-if="buyer"
                  v-model="buyer.add2"
                ></textarea>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-2 col-form-label">City:</label>
              <div class="col-md-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="City"
                  maxlength="50"
                  autocomplete="off"
                  v-if="buyer"
                  v-model="buyer.city"
                />
              </div>
              <label class="col-md-1 col-form-label">PIN:</label>
              <div class="col-md-2">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Pincode"
                  maxlength="6"
                  v-if="buyer"
                  v-model="buyer.pin"
                />
              </div>
              <div class="col-md-3">
                <select
                  id="cmbCountry"
                  class="form-control"
                  v-if="buyer"
                  v-model="buyer.country_cd"
                >
                  <option value="AF">Afghanistan</option>
                  <option value="AL">Albania</option>
                  <option value="DZ">Algeria</option>
                  <option value="AS">American Samoa</option>
                  <option value="AD">Andorra</option>
                  <option value="AO">Angola</option>
                  <option value="AR">Argentina</option>
                  <option value="AM">Armenia</option>
                  <option value="AU">Australia</option>
                  <option value="AT">Austria</option>
                  <option value="AZ">Azerbaijan</option>
                  <option value="BD">Bangladesh</option>
                  <option value="BE">Belgium</option>
                  <option value="BR">Brazil</option>
                  <option value="CA">Canada</option>
                  <option value="CN">China</option>
                  <option value="DK">Denmark</option>
                  <option value="EG">Egypt</option>
                  <option value="FR">France</option>
                  <option value="DE">Germany</option>
                  <option value="HK">Hong Kong</option>
                  <option value="IN" selected>India</option>
                  <option value="ID">Indonesia</option>
                  <option value="IR">Iran</option>
                  <option value="IQ">Iraq</option>
                  <option value="IE">Ireland</option>
                  <option value="IL">Israel</option>
                  <option value="IT">Italy</option>
                  <option value="JP">Japan</option>
                  <option value="KE">Kenya</option>
                  <option value="KR">South Korea</option>
                  <option value="MY">Malaysia</option>
                  <option value="MX">Mexico</option>
                  <option value="NP">Nepal</option>
                  <option value="NL">Netherlands</option>
                  <option value="NZ">New Zealand</option>
                  <option value="NG">Nigeria</option>
                  <option value="PK">Pakistan</option>
                  <option value="PH">Philippines</option>
                  <option value="QA">Qatar</option>
                  <option value="RU">Russia</option>
                  <option value="SA">Saudi Arabia</option>
                  <option value="SG">Singapore</option>
                  <option value="ZA">South Africa</option>
                  <option value="ES">Spain</option>
                  <option value="LK">Sri Lanka</option>
                  <option value="SE">Sweden</option>
                  <option value="CH">Switzerland</option>
                  <option value="TH">Thailand</option>
                  <option value="TR">Turkey</option>
                  <option value="AE">United Arab Emirates</option>
                  <option value="GB">United Kingdom</option>
                  <option value="US">United States</option>
                  <option value="VN">Vietnam</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-2 col-form-label">State:</label>
              <div class="col-md-4">
                <select
                  data-placeholder="Select your state"
                  class="form-control"
                  v-if="buyer"
                  v-model="buyer.state_cd"
                >
                  <option value="37">Andhra Pradesh</option>
                  <option value="35">Andaman and Nicobar Islands</option>
                  <option value="12">Arunachal Pradesh</option>
                  <option value="18">Assam</option>
                  <option value="10">Bihar</option>
                  <option value="04">Chandigarh</option>
                  <option value="22">Chhattisgarh</option>
                  <option value="26">Dadar and Nagar Haveli</option>
                  <option value="25">Daman and Diu</option>
                  <option value="07">Delhi</option>
                  <option value="30">Goa</option>
                  <option value="24">Gujarat</option>
                  <option value="06">Haryana</option>
                  <option value="02">Himachal Pradesh</option>
                  <option value="01">Jammu and Kashmir</option>
                  <option value="20">Jharkhand</option>
                  <option value="29">Karnataka</option>
                  <option value="32">Kerala</option>
                  <option value="31">Lakshadweep</option>
                  <option value="23">Madhya Pradesh</option>
                  <option value="27">Maharashtra</option>
                  <option value="14">Manipur</option>
                  <option value="17">Meghalaya</option>
                  <option value="15">Mizoram</option>
                  <option value="13">Nagaland</option>
                  <option value="21">Odisha</option>
                  <option value="96">Over Seas</option>
                  <option value="34">Pondicherry</option>
                  <option value="03">Punjab</option>
                  <option value="08">Rajasthan</option>
                  <option value="11">Sikkim</option>
                  <option value="33" selected="">Tamil Nadu</option>
                  <option value="36">Telangana</option>
                  <option value="16">Tripura</option>
                  <option value="09">Uttar Pradesh</option>
                  <option value="05">Uttarakhand</option>
                  <option value="19">West Bangal</option>
                </select>
              </div>
              <label class="col-md-1 col-form-label">Type:</label>
              <div class="col-md-2">
                <select
                  class="form-control"
                  v-if="buyer"
                  v-model="buyer.type"
                >
                  <option value="1">Regular</option>
                  <option value="2">Composite</option>
                  <option value="3">Unregistered</option>
                </select>
              </div>
              <label class="col-md-1 col-form-label">GSTIN:</label>
              <div class="col-md-2">
                <input
                  type="text"
                  class="form-control"
                  placeholder="GSTIN"
                  maxlength="15"
                  v-if="buyer"
                  v-model="buyer.gstin"
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-2 col-form-label">Opening Balance:</label>
              <div class="col-md-4">
                <input
                  type="number"
                  class="form-control text-right"
                  v-if="buyer"
                  v-model="buyer.opening_balance"
                />
              </div>
              <div class="col-md-1">
                <select
                  id="cmbcrdr"
                  class="form-control"
                  v-if="buyer"
                  v-model="buyer.is_crdr"
                >
                  <option value="1">Cr</option>
                  <option value="-1">Dr</option>
                </select>
              </div>
            </div>
            <div class="text-right">
              <button
                type="submit"
                class="btn btn-primary legitRipple"
                @click="saveDocument"
              >
                Save <i class="icon-paperplane ml-2"></i>
              </button>
            </div>
          </div>

          <!-- Shipping Address Tab -->
          <div
            class="tab-pane fade"
            :class="{ 'show active': activeTab === 'shippingaddress' }"
          >
            <div class="form-group row">
              <label class="col-md-2 col-form-label">Ship Name:</label>
              <div class="col-md-10">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Shipping Name"
                  maxlength="100"
                  v-if="buyer"
                  v-model="buyer.ship_name"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-2 col-form-label">Ship Add 1:</label>
              <div class="col-md-10">
                <textarea
                  rows="1"
                  class="form-control"
                  placeholder="Enter shipping address here"
                  v-if="buyer"
                  v-model="buyer.ship_add1"
                ></textarea>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-2 col-form-label">Ship Add 2:</label>
              <div class="col-md-10">
                <textarea
                  rows="1"
                  class="form-control"
                  placeholder="Enter shipping address here"
                  v-if="buyer"
                  v-model="buyer.ship_add2"
                ></textarea>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-2 col-form-label">Ship City:</label>
              <div class="col-md-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Shipping City"
                  maxlength="50"
                  autocomplete="off"
                  v-if="buyer"
                  v-model="buyer.ship_city"
                />
              </div>
              <label class="col-md-1 col-form-label">Ship PIN:</label>
              <div class="col-md-2">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Shipping Pincode"
                  maxlength="6"
                  v-if="buyer"
                  v-model="buyer.ship_pin"
                />
              </div>
              <div class="col-md-3">
                <select
                  class="form-control"
                  v-if="buyer"
                  v-model="buyer.ship_country_cd"
                >
                  <option value="AF">Afghanistan</option>
                  <option value="AL">Albania</option>
                  <option value="DZ">Algeria</option>
                  <option value="AS">American Samoa</option>
                  <option value="AD">Andorra</option>
                  <option value="AO">Angola</option>
                  <option value="AR">Argentina</option>
                  <option value="AM">Armenia</option>
                  <option value="AU">Australia</option>
                  <option value="AT">Austria</option>
                  <option value="AZ">Azerbaijan</option>
                  <option value="BD">Bangladesh</option>
                  <option value="BE">Belgium</option>
                  <option value="BR">Brazil</option>
                  <option value="CA">Canada</option>
                  <option value="CN">China</option>
                  <option value="DK">Denmark</option>
                  <option value="EG">Egypt</option>
                  <option value="FR">France</option>
                  <option value="DE">Germany</option>
                  <option value="HK">Hong Kong</option>
                  <option value="IN" selected>India</option>
                  <option value="ID">Indonesia</option>
                  <option value="IR">Iran</option>
                  <option value="IQ">Iraq</option>
                  <option value="IE">Ireland</option>
                  <option value="IL">Israel</option>
                  <option value="IT">Italy</option>
                  <option value="JP">Japan</option>
                  <option value="KE">Kenya</option>
                  <option value="KR">South Korea</option>
                  <option value="MY">Malaysia</option>
                  <option value="MX">Mexico</option>
                  <option value="NP">Nepal</option>
                  <option value="NL">Netherlands</option>
                  <option value="NZ">New Zealand</option>
                  <option value="NG">Nigeria</option>
                  <option value="PK">Pakistan</option>
                  <option value="PH">Philippines</option>
                  <option value="QA">Qatar</option>
                  <option value="RU">Russia</option>
                  <option value="SA">Saudi Arabia</option>
                  <option value="SG">Singapore</option>
                  <option value="ZA">South Africa</option>
                  <option value="ES">Spain</option>
                  <option value="LK">Sri Lanka</option>
                  <option value="SE">Sweden</option>
                  <option value="CH">Switzerland</option>
                  <option value="TH">Thailand</option>
                  <option value="TR">Turkey</option>
                  <option value="AE">United Arab Emirates</option>
                  <option value="GB">United Kingdom</option>
                  <option value="US">United States</option>
                  <option value="VN">Vietnam</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-2 col-form-label">Ship State:</label>
              <div class="col-md-4">
                <select
                  data-placeholder="Select shipping state"
                  class="form-control"
                  v-if="buyer"
                  v-model="buyer.ship_state_cd"
                >
                  <option value="37">Andhra Pradesh</option>
                  <option value="35">Andaman and Nicobar Islands</option>
                  <option value="12">Arunachal Pradesh</option>
                  <option value="18">Assam</option>
                  <option value="10">Bihar</option>
                  <option value="04">Chandigarh</option>
                  <option value="22">Chhattisgarh</option>
                  <option value="26">Dadar and Nagar Haveli</option>
                  <option value="25">Daman and Diu</option>
                  <option value="07">Delhi</option>
                  <option value="30">Goa</option>
                  <option value="24">Gujarat</option>
                  <option value="06">Haryana</option>
                  <option value="02">Himachal Pradesh</option>
                  <option value="01">Jammu and Kashmir</option>
                  <option value="20">Jharkhand</option>
                  <option value="29">Karnataka</option>
                  <option value="32">Kerala</option>
                  <option value="31">Lakshadweep</option>
                  <option value="23">Madhya Pradesh</option>
                  <option value="27">Maharashtra</option>
                  <option value="14">Manipur</option>
                  <option value="17">Meghalaya</option>
                  <option value="15">Mizoram</option>
                  <option value="13">Nagaland</option>
                  <option value="21">Odisha</option>
                  <option value="96">Over Seas</option>
                  <option value="34">Pondicherry</option>
                  <option value="03">Punjab</option>
                  <option value="08">Rajasthan</option>
                  <option value="11">Sikkim</option>
                  <option value="33" selected="">Tamil Nadu</option>
                  <option value="36">Telangana</option>
                  <option value="16">Tripura</option>
                  <option value="09">Uttar Pradesh</option>
                  <option value="05">Uttarakhand</option>
                  <option value="19">West Bangal</option>
                </select>
              </div>
            </div>
            <div class="text-right">
              <button
                type="submit"
                class="btn btn-primary legitRipple"
                @click="saveDocument"
              >
                Save <i class="icon-paperplane ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </FocusTrap>
</template>

<script>
import { userService } from '@/store/auth-header.js'

export default {
  name: 'BuyerForm',
  data() {
    // Define default buyer object centrally, including shipping fields
    const defaultBuyer = {
      id: 0,
      status: "",
      type: 0,
      name: "",
      add1: "",
      add2: "",
      city: "",
      pin: "",
      state_cd: 33,
      country_cd: "IN",
      tel: "",
      mobile: "",
      email: "",
      web: "",
      gstin: "",
      opening_balance: 0,
      is_crdr: 1, // Default to Credit
      // Shipping Address Fields
      ship_name: "",
      ship_add1: "",
      ship_add2: "",
      ship_city: "",
      ship_pin: "",
      ship_state_cd: 33, // Default to Tamil Nadu
      ship_country_cd: "IN" // Default to India
    };
    return {
      activeTab: 'billingaddress', // Add activeTab to data
      buyer: { ...defaultBuyer } // Initialize buyer with a copy of the default
    }
  },
  // component: { }, // Removed empty component block
  props: {
    mybuyer: {
      type: Object,
      required: true,
      // Use factory function for default
      default() {
        return {
          id: 0,
          status: "",
          type: 0,
          name: "",
          add1: "",
          add2: "",
          city: "",
          pin: "",
          state_cd: 33,
          country_cd: "IN",
          tel: "",
          mobile: "",
          email: "",
          web: "",
          gstin: "",
          opening_balance: 0,
          is_crdr: 1,
          // Shipping Address Fields (default props)
          ship_name: "",
          ship_add1: "",
          ship_add2: "",
          ship_city: "",
          ship_pin: "",
          ship_state_cd: 33,
          ship_country_cd: "IN"
        };
      }
    }
  },
  beforeMount () {
    // Copy prop data to local data, including shipping fields
    this.buyer = { ...this.mybuyer }; // Use spread for shallow copy
    // Ensure is_crdr and opening_balance are set correctly based on the opening balance value
    this.buyer.is_crdr = (this.buyer.opening_balance > 0 ? 1 : (this.buyer.opening_balance < 0 ? -1 : 1)); // Handle 0 case
    this.buyer.opening_balance = Math.abs(this.buyer.opening_balance);
  },
  // created () { ... } // Removed the created hook that overwrote data
  mounted () {
    // $('.form-control-select2').select2() // Removed jQuery select2 initialization
    // $('#txtname').focus(); // Replaced with Vue ref
    if (this.$refs.txtname) {
      this.$refs.txtname.focus();
    }
  },
  methods: {
    closeWindow(){
      // Reset to default using the central definition, including shipping fields
      const defaultBuyer = {
        id: 0,
        status: "",
        type: 0,
        name: "",
        add1: "",
        add2: "",
        city: "",
        pin: "",
        state_cd: 33,
        country_cd: "IN",
        tel: "",
        mobile: "",
        email: "",
        web: "",
        gstin: "",
        opening_balance: 0,
        is_crdr: 1,
        // Shipping Address Fields
        ship_name: "",
        ship_add1: "",
        ship_add2: "",
        ship_city: "",
        ship_pin: "",
        ship_state_cd: 33,
        ship_country_cd: "IN"
      };
      this.buyer = { ...defaultBuyer };
      this.$emit("buyer_window_closed");
    },
    saveDocument(){
      // const self = this; // Not strictly necessary with arrow functions or direct 'this' usage
      // Use the v-model bound value directly, no need for parseInt on type if input type is number or v-model.number used
      // Ensure type is an integer
      this.buyer.type = parseInt(this.buyer.type, 10) || 0;
      if(this.buyer.name == null || this.buyer.name.toString().length < 5){
        alert("Invalid Name");
        return;
      }else if( this.buyer.city == null || this.buyer.city.trim().length <= 3 ){
        alert("Invalid City");
        return;
      }else if( parseInt(this.buyer.state_cd, 10) < 1 ){
        alert("Invalid State selected");
        return;
      }
      // Ensure state_cd is an integer
      this.buyer.state_cd = parseInt(this.buyer.state_cd, 10) || 0;
      // Ensure ship_state_cd is an integer if present
      if (this.buyer.ship_state_cd !== undefined) {
        this.buyer.ship_state_cd = parseInt(this.buyer.ship_state_cd, 10) || 0;
      }

      // Calculate final opening balance using the v-model bound is_crdr and opening_balance
      // Use parseFloat for the balance to handle decimals correctly
      const balanceValue = parseFloat(this.buyer.opening_balance) || 0;
      const crdrValue = parseInt(this.buyer.is_crdr, 10) || 1; // Default to 1 (Cr) if parsing fails
      this.buyer.opening_balance = crdrValue * Math.abs(balanceValue);

      console.log(JSON.stringify(this.buyer)); // Log the buyer object directly
      const requestOptions = {
        method:  (this.buyer.id == 0 ? 'POST' : 'PUT'),
        mode:"cors",
        headers: userService.authHeader(),
        body: JSON.stringify(this.buyer) // Send the buyer object directly
      };
      fetch(`${process.env.VUE_APP_ROOT_API}api/buyer`,requestOptions).then(userService.handleResponse).then((resp) => { // Use arrow function to preserve 'this'
        if(resp.ok) {
          swal ( { title: "Success!" ,  text: resp.msg, type:  "success", timer: 3000} );
          this.$emit('buyer_saved', resp.data); // Use 'this' context
        } else {
          swal ( { title: "Oops!" ,  text: resp.msg, type:  "error"} );
        }
      }).catch((err) => { // Use arrow function to preserve 'this'
        swal ( { title: "Oh noes!" ,  text: err.toString(), type:  "error"} );
      });
    }
  }
}
</script>

<style scoped>
/* ... (existing styles) ... */
/* Basic tab styling - adjust as needed for your theme */
.nav-tabs .nav-link {
  cursor: pointer;
}
.nav-tabs .nav-link.active {
  background-color: #f8f9fa; /* Example active tab background */
  border-bottom-color: #f8f9fa; /* Match card body background */
}
.tab-content {
  min-height: 200px; /* Ensure content area has some height */
}
/* Ensure focus styles still apply within tabs */
.tab-content input:focus,
.tab-content textarea:focus,
.tab-content select:focus {
  background: #feff00;
}
.tab-content button:focus {
  background: #feff00;
  color: #0a0a0a !important;
}
</style>
